import { render } from "./CasesList.vue?vue&type=template&id=3eb64631&scoped=true"
import script from "./CasesList.vue?vue&type=script&lang=js"
export * from "./CasesList.vue?vue&type=script&lang=js"

import "./CasesList.vue?vue&type=style&index=0&id=3eb64631&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3eb64631"]])

export default __exports__